import { CmsTheme, LuckyBirdTheme } from 'pages/CMS/CMS.types'
import { getRequest } from 'utils/api/apiRequest'
import { WithPagination } from 'utils/api/pagination'

export type FetchThemes = WithPagination<CmsTheme>
export type FetchLuckyBirdTheme = LuckyBirdTheme
export const fetchThemes = () => getRequest<FetchThemes>('/cms/theme').then((data) => data.data)
export const fetchLBTheme = () => getRequest<FetchLuckyBirdTheme>('/lucky-bird/theme').then((data) => data.data)
